import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';
import { DefaultCollectContext } from '../..';

export const ModalAcceptResponsibilityTerms = () => {
  const { Modal, closeModal } = useModal();

  const {
    setDocumentType,
    setHasAcceptResponsibilityTerms,
    openCreateDeclarationModal
  } = useContext(DefaultCollectContext);

  const handleAcceptTerms = () => {
    closeModal();
    setDocumentType('declaration');
    setHasAcceptResponsibilityTerms(true);
    openCreateDeclarationModal();
  };

  const handleRejectTerms = () => {
    setDocumentType('');
    setHasAcceptResponsibilityTerms(false);
    closeModal();
  };

  return (
    <Modal closeFunction={handleRejectTerms}>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          maxHeight: '86vh',
          overflow: 'auto'
        }}
      >
        <ModalTitle>Termo de Responsabilidade</ModalTitle>

        <ModalText>
          Declaro, para os devidos fins de direito que as mercadorias
          relacionadas nesta declaração e entregues a transporte para a
          BRASPRESS TRANSPORTES URGENTES LTDA. estão legalmente dispensadas da
          emissão de nota fiscal por se enquadrarem em alguma(s) das condições a
          seguir:
        </ModalText>

        <ModalText>
          *Pessoa física e empresas não contribuintes, que por lei estão
          dispensadas de emissão de Nota Fiscal.
        </ModalText>

        <ModalText>
          Estou ciente que a inexatidão das informações prestadas poderá ensejar
          penalizações e multas de minha responsabilidade.
        </ModalText>

        <Box style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
          <Button
            type="button"
            variant="contained"
            color="secondary"
            data-testid="rejectResponsibilityTermsModalButton"
            onClick={handleRejectTerms}
          >
            Cancelar
          </Button>
          <Button
            type="button"
            data-testid="acceptResponsibilityTermsModalButton"
            variant="contained"
            onClick={handleAcceptTerms}
          >
            Aceitar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
